<template>
  <div>
    <div class="weui-cells__title">
      基本信息
      <span class="iconback" @click="back">
        <i class="iconfont icon-back"></i> 返回个人中心
      </span>
    </div>
    <div class="weui-cells" style="margin-top: 0px">
      <a class="weui-cell weui-cell_access" href="javascript:;">
        <div class="weui-cell__bd">
          <p>头像</p>
        </div>
        <div class="weui-cell__hd">
          <img
            class="headerimg"
            :src="'data:image/png;base64,' + userInfo.headimgBase64"
            alt
            style="margin-right: 5px; display: block"
          />
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="editWorksite"
      >
        <div class="weui-cell__bd">
          <p>网点</p>
        </div>
        <div class="weui-cell__ft">
          {{
            userInfo.worksite.shortName +
            " - (" +
            userInfo.worksite.schoolCampus +
            ")"
          }}
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="editNickname"
      >
        <div class="weui-cell__bd">
          <p>昵称</p>
        </div>
        <div
          class="weui-cell__ft"
          style="
            width: 160px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          "
        >
          {{ userInfo.nickname }}
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="editSex"
      >
        <div class="weui-cell__bd">
          <p>性别</p>
        </div>
        <div class="weui-cell__ft">{{ userInfo.sexStr }}</div>
      </a>
    </div>

    <div class="weui-cells__title">联系电话</div>
    <div class="weui-cells">
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="editPhoneMain"
      >
        <div class="weui-cell__bd">
          <p>主手机号</p>
        </div>
        <div class="weui-cell__ft">
          {{ userInfo.phoneMain ? userInfo.phoneMain : "去设置" }}
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        @click="editPhoneVice"
      >
        <div class="weui-cell__bd">
          <p>副手机号</p>
        </div>
        <div class="weui-cell__ft">
          {{ userInfo.phoneVice ? userInfo.phoneVice : "去设置" }}
        </div>
      </a>
    </div>

    <div class="weui-cells__title">实名信息</div>
    <div class="weui-cells">
      <a class="weui-cell weui-cell_access" href="javascript:;">
        <div class="weui-cell__bd">
          <p>姓名</p>
        </div>
        <div class="weui-cell__hd">{{ userInfo.realname }}</div>
      </a>
      <a class="weui-cell weui-cell_access" href="javascript:;">
        <div class="weui-cell__bd">
          <p>身份证号码</p>
        </div>
        <div class="weui-cell__hd">{{ userInfo.idCardNo }}</div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        v-if="haveIdCard"
        @click="showImagePreview(userInfo.idCardUrl)"
      >
        <div class="weui-cell__bd">
          <p>身份证照片</p>
        </div>
        <div class="weui-cell__hd">
          <img class="block-img" :src="userInfo.idCardUrl" alt />
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        v-if="!haveIdCard"
      >
        <div class="weui-cell__bd">
          <p>身份证照片</p>
        </div>
        <div class="weui-cell__hd">
          <img class="block-img" :src="userInfo.idCardUrl" alt />
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        v-if="haveStudentCard"
        @click="showImagePreview(userInfo.studentCardUrl)"
      >
        <div class="weui-cell__bd">
          <p>学生证照片</p>
        </div>
        <div class="weui-cell__hd">
          <img class="block-img" :src="userInfo.studentCardUrl" alt />
        </div>
      </a>
      <a
        class="weui-cell weui-cell_access"
        href="javascript:;"
        v-if="!haveStudentCard"
      >
        <div class="weui-cell__bd">
          <p>学生证照片</p>
        </div>
        <div class="weui-cell__hd">
          <img class="block-img" :src="userInfo.studentCardUrl" alt />
        </div>
      </a>
    </div>

    <div class="footer">
      <div class="footer-item" @click="unbindPhoneMain">解绑主手机</div>
      <div
        class="footer-item"
        @click="unbindPhoneVice"
        v-if="userInfo.phoneVice"
      >
        解绑副手机
      </div>
    </div>

    <div
      class="unverify"
      v-if="haveStudentCard || haveIdCard"
      @click="unverify"
    >
      取消实名认证
    </div>
  </div>
</template>

<script>
import weui from "weui.js";
import axios from "axios";
import config from "../config/config.js";

export default {
  data() {
    return {
      defaultImgBase64: "",
      platform: "",
      encodeToken: "",
      token: "",
      userInfo: {
        headimgBase64: "",
        worksite: {
          fullName: "",
          schoolCampus: "",
        },
      },
      haveIdCard: false,
      haveStudentCard: false,
      imgs: [],
    };
  },
  created() {
    let that = this;
    this.platform = this.$route.params.platform;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    this.defaultImgBase64 = config.defaultImgBase64;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then((response) => {
        that.userInfo = response.data.data;

        if (!that.userInfo.idCardUrl) {
          that.userInfo.idCardUrl = config.defaultImgBase64;
        } else {
          that.haveIdCard = true;
        }
        if (!that.userInfo.studentCardUrl) {
          that.userInfo.studentCardUrl = config.defaultImgBase64;
        } else {
          that.haveStudentCard = true;
        }

        if (that.userInfo.sex == 0) {
          that.userInfo.sexStr = "未知";
        } else if (that.userInfo.sex == 1) {
          that.userInfo.sexStr = "男";
        } else if (that.userInfo.sex == 2) {
          that.userInfo.sexStr = "女";
        }
      })
      .catch((error) => {
        console.log(error);
        weui.topTips("获取用户信息失败", 2000);
      });
  },
  methods: {
    back() {
      if (this.platform == "express") {
        this.$router.push("/my/" + this.encodeToken);
      } else if (this.platform == "live") {
        window.location.href =
          "http://live.aixyt.com/#/home/0/" + this.encodeToken + "/info";
      }
    },
    editWorksite() {
      this.$router.push({
        name: "WorksiteList",
        params: {
          token: this.encodeToken,
          from: "userInfo",
          platform: this.platform,
        },
      });
    },
    editRealname() {
      this.$router.push({
        name: "RealnameEdit",
        params: {
          token: this.encodeToken,
          platform: this.platform,
        },
      });
    },
    editNickname() {
      this.$router.push({
        name: "NicknameEdit",
        params: {
          token: this.encodeToken,
          platform: this.platform,
        },
      });
    },
    editSex() {
      this.$router.push({
        name: "SexEdit",
        params: {
          token: this.encodeToken,
          platform: this.platform,
        },
      });
    },
    editPhoneMain() {
      this.$router.push({
        name: "PhoneEdit",
        params: {
          token: this.encodeToken,
          type: "main",
          platform: this.platform,
        },
      });
    },
    editPhoneVice() {
      this.$router.push({
        name: "PhoneEdit",
        params: {
          token: this.encodeToken,
          type: "vice",
          platform: this.platform,
        },
      });
    },
    showImagePreview(img) {
      this.imgs = [img];
      this.$createImagePreview({
        imgs: this.imgs,
      }).show();
    },
    unbindPhoneMain() {
      let title = "";
      if (this.userInfo.phoneVice) {
        title = "解绑主手机号后副手机号将成为您的主手机号，确定解绑？";
      } else {
        title = "确定解绑主手机？";
      }
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        content: title,
        confirmBtn: {
          text: "确 定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
        cancelBtn: {
          text: "取 消",
          active: false,
          disabled: false,
          href: "javascript:;",
        },
        onConfirm: () => {
          let loading = weui.loading("解绑ing...", {
            className: "custom-classname",
          });
          axios
            .put("/api/user/unbindPhoneMain")
            .then((res) => {
              loading.hide(function () {});
              if (res.data.success) {
                weui.toast("操作成功", 500);
                if (res.data.data) {
                  this.userInfo.phoneVice = "";
                  this.userInfo.phoneMain = res.data.data;
                } else {
                  this.$router.push("/addUserInfo/my/" + this.encodeToken);
                }
              } else {
                weui.alert("操作失败", 500);
              }
            })
            .catch((err) => {
              loading.hide(function () {});
              console.log(err);
            });
        },
      }).show();
    },
    unbindPhoneVice() {
      if (!this.userInfo.phoneVice) {
        weui.alert("还没绑定副手机");
        return;
      }
      let title = "确定解绑副手机？";
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        content: title,
        confirmBtn: {
          text: "确 定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
        cancelBtn: {
          text: "取 消",
          active: false,
          disabled: false,
          href: "javascript:;",
        },
        onConfirm: () => {
          let loading = weui.loading("解绑ing...", {
            className: "custom-classname",
          });
          axios
            .put("/api/user/unbindPhoneVice")
            .then((res) => {
              loading.hide(function () {});
              if (res.data.success) {
                weui.toast("操作成功", 500);
                this.userInfo.phoneVice = "";
              } else {
                weui.alert("操作失败", 500);
              }
            })
            .catch((err) => {
              loading.hide(function () {});
              console.log(err);
            });
        },
      }).show();
    },
    unverify() {
      this.$createDialog({
        type: "confirm",
        icon: "cubeic-alert",
        content: "确定取消实名认证？",
        confirmBtn: {
          text: "确 定",
          active: true,
          disabled: false,
          href: "javascript:;",
        },
        cancelBtn: {
          text: "取 消",
          active: false,
          disabled: false,
          href: "javascript:;",
        },
        onConfirm: () => {
          let loading = weui.loading("处理ing...", {
            className: "custom-classname",
          });
          axios
            .put("/api/user/unverifySelf")
            .then((res) => {
              loading.hide(function () {});
              if (res.data.success) {
                weui.toast("操作成功", 500);
                this.userInfo.authStatus = -1;
                this.userInfo.idCardUrl = null;
                this.userInfo.studentCardUrl = null;
                this.haveIdCard = false;
                this.haveStudentCard = false;
              } else {
                weui.alert("操作失败", 500);
              }
            })
            .catch((err) => {
              loading.hide(function () {});
              console.log(err);
            });
        },
      }).show();
    },
  },
};
</script>

<style scoped>
.redTips {
  color: red;
  position: relative;
  top: 2px;
  vertical-align: middle;
  font-weight: bold;
}
.iconback {
  float: right;
  font-weight: bold;
  color: red;
}
.headerimg {
  width: 50px;
  height: 50px;
  border-radius: 8px;
}
.weui-cell__bd input {
  text-align: right;
}
.weui-select {
  width: auto;
}
.footer {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
  display: flex;
  width: 100%;
}
.footer-item {
  flex: 1;
  text-align: center;
  color: #ffffff;
}
.footer-item:last-child {
  background-color: #feb70f;
}
.footer-item:first-child {
  background-color: red;
}
.unverify {
  text-align: center;
  color: #ffffff;
  background-color: red;
  margin-top: 10px;
  font-size: 18px;
  line-height: 50px;
}
</style>
<style>
.weui-picker__item {
  font-size: 18px !important;
}
.weui-cell__hd .block-img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  display: block;
}
</style>






// WEBPACK FOOTER //
// src/components/UserInfo.vue